import React from "react";
import WelcomePage from "./General/general";

export const WelcomeRouter = ({ org_rol_s, org_id, setNavSelection, setSelApiAttribute, setCategoryName,dataCollectionTypes }) => {

return (
    <>
        <WelcomePage org_rol_s={org_rol_s} org_id={org_id} 
        setNavSelection={setNavSelection} setSelApiAttribute={setSelApiAttribute} 
        setCategoryName={setCategoryName} 
        dataCollectionTypes={dataCollectionTypes}/>
    </>
)};